import { ViewModel as FcSidebarViewModel } from "../../fc-sidebar/model";

export function ViewModel(params, element) {
  element.classList.add("vap-sidebar");
  return FcSidebarViewModel(params, element);
}
